// extracted by mini-css-extract-plugin
module.exports = {"footerContent":"TwoFactorDangerModal_footerContent__2ydhm"};